import {IPaylodAction} from '../interfaces/dispatchers/IAction'
import {RegImportAction} from '../enums/ActionTypes/RegImportAction'
import {IRegImport} from '../interfaces/reducers/IRegImport'
import {CoordinateSystem} from '../core/enums/CoordinateSystem'

const initState: IRegImport = {
  inputData: {
    cp1251: true,
    loading: false,
    dataCS: CoordinateSystem.BG_705,
    planName: '',
    planApprover: 'Общински съвет',
    planDate: new Date(),
    approvedDate: undefined,
    expanded: false,
    cm5Checked: true,
    AddIndexesToDuplicateNumbers: false,
    planType: 2,
    layerNames: {
      kvLayer: 'RP_REGO',
      kvBlock: 'KW',
      kvTag: 'KWNOM',

      parcelLayer: 'RP_PAR',
      parcelBlockLayer: 'RP_NPAR',
      parcelBlockName: 'PRPARC',
      parcelTag: 'NPARCEL',
      parcelCadTag: 'NIMOT',
      parcelPr1: 'PR1',
      parcelPr2: 'PR2',
      parcelPr3: 'PR3',
      parcelPr4: 'PR4',
      parcelPr5: 'PR5',

      oParcelLayer: 'RP_OB',
      oParcelBlockLayer: 'RP_NOB',
      oParcelBlockName: 'PRPARC',
      oParcelTag: 'NPARCEL',
      oParcelCadTag: 'NIMOT',
      oParcelPr1: 'PR1',
      oParcelPr2: 'PR2',
      oParcelPr3: 'PR3',
      oParcelPr4: 'PR4',
      oParcelPr5: 'PR5',

      OSLineLayer: 'RP_OS',

      TrotoLayer: 'RP_REGT',

      OTBlockName: 'OT',
      OTNomerTag: 'NOMER',
      OTKotaTag: 'KOTA',
      OTCreatedTag: 'CREATOR',
      OTDescTag: 'DESCRIPTION'
    },
    startedImportGuid: '',
    errors: [],
    Edits: 0
  },
  readValidationData: {
    loading: false,
    errors: [],
    exists: false
  },
  connectValidationData: {
    loading: false,
    errors: {messages: [], dxf: ''},
    exists: false
  },
  importActionData: {
    loading: false,
    errors: [],
    success: false
  }
}
const regImport = (state: IRegImport = initState, action: IPaylodAction): IRegImport => {
  switch (action.type) {
    case RegImportAction.UPDATE_IMPORT_DATA:
      return {...state, inputData: {...action.payload}}
    case RegImportAction.UPDATE_IMPORT_DATA_LAYERS:
      return {...state, inputData: {...state.inputData, layerNames: {...action.payload}}}
    case RegImportAction.UPDATE_READ_VALIDATE_DATA:
      return {...state, readValidationData: {...action.payload}}
    case RegImportAction.UPDATE_CONNECT_VALIDATE_DATA:
      return {...state, connectValidationData: {...action.payload}}
    case RegImportAction.UPDATE_IMPORT_ACTION_DATA:
      return {...state, importActionData: {...action.payload}}
    default:
      return state
  }
}
export default regImport
